import { createContext, useContext, useEffect, useState, type ReactNode } from "react";

/**
 * Der Weg in der Kopfleiste: Projekte › BVE Tinnumer Weg › Besprechungen › Nr. 15.
 *
 * Jeder Bildschirm meldet seinen Weg mit `usePfad(...)`; die Kopfleiste zeigt ihn und
 * daneben einen Zurück-Pfeil auf die vorletzte Stufe. Vorher stand der Rückweg als kleine
 * Zeile über der Überschrift im Inhalt und scrollte mit weg — im Protokoll, das lang ist
 * und auf dem Tablet bearbeitet wird, kam man nicht mehr zurück.
 *
 * Verworfen: `history.back()` als Zurück. Wer per Link direkt im Protokoll landet (Mail,
 * Lesezeichen), hätte keine Vorgeschichte, und der Pfeil führte aus der Anwendung hinaus.
 */
export interface Stufe {
  titel: string;
  /** Ohne `nach` ist es die aktuelle Seite (nicht klickbar). */
  nach?: string;
}

const Kontext = createContext<{ pfad: Stufe[]; setze: (p: Stufe[]) => void }>({
  pfad: [], setze: () => {},
});

export function PfadAnbieter({ children }: { children: ReactNode }) {
  const [pfad, setze] = useState<Stufe[]>([]);
  return <Kontext.Provider value={{ pfad, setze }}>{children}</Kontext.Provider>;
}

export function usePfadLesen(): Stufe[] {
  return useContext(Kontext).pfad;
}

/** Meldet den Weg dieses Bildschirms. Als Text verglichen, damit ein neues Array mit
 *  gleichem Inhalt keinen Neuanstrich der Kopfleiste auslöst. */
export function usePfad(pfad: Stufe[]): void {
  const { setze } = useContext(Kontext);
  const schluessel = JSON.stringify(pfad);
  useEffect(() => {
    setze(JSON.parse(schluessel));
  }, [schluessel, setze]);
}
